import React from 'react';

interface IconProps {
  size?: number;
  className?: string;
}

export const MicrosoftIcon: React.FC<IconProps> = ({ size = 32, className }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    aria-label="Microsoft"
  >
    <rect x="2" y="2" width="13" height="13" fill="#F25022" />
    <rect x="17" y="2" width="13" height="13" fill="#7FBA00" />
    <rect x="2" y="17" width="13" height="13" fill="#00A4EF" />
    <rect x="17" y="17" width="13" height="13" fill="#FFB900" />
  </svg>
);
